import { useEffect } from 'react';

import { appState, useMyCareerCenter } from 'core';
import { NetworkErrors } from 'context';

/**
 * Route guard for every /career page.
 *
 * A student who is not enrolled has no Career Center at all, so a direct URL
 * hit lands on the 404 page rather than an empty section — the same treatment
 * the Invoices/Surveys pages give an ineligible role.
 *
 * Методист проходит гард по серверному флагу `isPreview`, а НЕ по членству
 * (ТЗ 0039 доводка): участником он не является и никогда не станет, но раздел
 * ему открыт. Проверять роль здесь самим нельзя — право решает сервер.
 *
 * The redirect waits for `loading` to settle: firing on the first render would
 * bounce every member to 404 before `myCareerCenter` has come back.
 *
 * This is UX, not enforcement — the server independently refuses career data to
 * non-members (spec 0018 §3.3), so bypassing this guard reveals nothing.
 */
export const useCareerAccessGuard = () => {
  const { center, isMember, isPreview, loading, error } = useMyCareerCenter();

  useEffect(() => {
    if (loading || error || isMember || isPreview) {
      return;
    }

    appState({ ...appState(), networkError: NetworkErrors.pageIsNotAvailable });
  }, [loading, error, isMember, isPreview]);

  return { center, isMember, isPreview, loading, error };
};
